import React, { createContext, useContext, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const RouteHistoryContext = createContext({
  previousPath: null,
  currentPath: '/',
});

export const RouteHistoryProvider = ({ children }) => {
  const location = useLocation();
  const previousPathRef = useRef(null);

  const value = useMemo(
    () => ({
      previousPath: previousPathRef.current,
      currentPath: location.pathname,
    }),
    [location.pathname]
  );

  useEffect(() => {
    previousPathRef.current = location.pathname;
  }, [location.pathname]);

  return (
    <RouteHistoryContext.Provider value={value}>
      {children}
    </RouteHistoryContext.Provider>
  );
};

export const useRouteHistory = () => useContext(RouteHistoryContext);

